import { useMutation } from '@tanstack/react-query';
import leadUseCase from '../factories/lead';

export const useCreateLead = (options = {}) => {
  return useMutation(leadUseCase.createLead, options);
};
